import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./CreateProject.css";
import Navbar from "../../../components/Navbar";
import api from "../../../services/api";

const CreateProject = ({ role, onCancel, onCreateSuccess }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "active",
    startDate: new Date().toISOString().split("T")[0],
    clientName: "",
  });

  useEffect(() => {
    const fetchCurrentUser = async () => {
      try {
        const userInfo = JSON.parse(localStorage.getItem("user"));
        if (userInfo && userInfo.id) {
          setUserId(userInfo.id);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Authentication error. Please log in again.");
      }
    };

    fetchCurrentUser();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      setLoading(true);

      const projectData = {
        title: formData.name,
        description: formData.description,
        status: formData.status,
        start_date: formData.startDate,
        clientName: formData.clientName,
        user_id: userId,
      };

      const response = await api.post("/projects", projectData);
      console.log("Project created:", response.data);

      navigate(`/${role}/manage-projects`);
      if (onCreateSuccess) {
        onCreateSuccess();
      }
    } catch (err) {
      console.error("Error creating project:", err);
      setError(err.response?.data?.message || "Failed to create project");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    if (
      window.confirm(
        "Are you sure you want to cancel? All changes will be lost."
      )
    ) {
      navigate("/admin/manage-projects");
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    if (error) setError(null);
  };

  return (
    <>
      <div className="create-project-container">
        <Navbar role={role} />
        <h1 className="create-project-heading">Create Project</h1>

        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}
        <form
          className="create-project-form"
          onSubmit={handleSubmit}
          noValidate
        >
          <div className="form-section">
            <h3>Basic Information</h3>
            <div className="form-group">
              <label htmlFor="name" className="required">
                Project Name
              </label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={handleChange}
                aria-required="true"
                aria-invalid={!formData.name.trim()}
                disabled={loading}
                required
                placeholder="Enter project name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="description" className="required">
                Description
              </label>
              <textarea
                id="description"
                value={formData.description}
                onChange={handleChange}
                aria-required="true"
                aria-invalid={!formData.description.trim()}
                disabled={loading}
                required
                placeholder="Describe the project goals, scope, and other relevant details"
              />
            </div>
            <div className="form-group">
              <label htmlFor="status" className="required">
                Status
              </label>
              <select
                id="status"
                value={formData.status}
                onChange={handleChange}
                disabled={loading}
              >
                <option value="active">Active</option>
                <option value="completed">Completed</option>
                <option value="on-hold">On Hold</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="startDate" className="required">
                Start Date
              </label>
              <input
                type="date"
                id="startDate"
                value={formData.startDate}
                onChange={handleChange}
                aria-required="true"
                aria-invalid={!formData.startDate}
                disabled={loading}
                required
                placeholder="Select a start date"
              />
            </div>
            <div className="form-group">
              <label htmlFor="clientName" className="required">
                Client Name
              </label>
              <input
                type="text"
                id="clientName"
                value={formData.clientName}
                onChange={handleChange}
                aria-required="true"
                aria-invalid={!formData.clientName.trim()}
                disabled={loading}
                required
                placeholder="Enter client name or organization"
              />
            </div>
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="secondary-button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="secondary-button"
              disabled={loading}
            >
              {loading ? "Creating..." : "Create Project"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateProject;
